// Calendar.js
// import React from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { CiCalendarDate } from "react-icons/ci";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { GetAgendas } from "../actions/agenda";
import { GetServicios } from "../actions/servicio";

import { useState } from "react";
import style from "../styles/agenda.module.css";

moment.locale("es");

function MyCalendar() {
   const servicios = GetServicios();
   const localizer = momentLocalizer(moment);
   const [showModal, setShowModal] = useState(false);

   const messages = {
      // new
      allDay: "Todos",
      previous: "Anterior",
      next: "Proximo",
      today: "Hoy",
      month: "Mes",
      week: "Semana",
      day: "Dia",
      agenda: "Agenda",
      date: "Fecha",
      time: "Hora",
      event: "Evento",
   };

   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "agenda";
   let fecha = new Date();
   console.log(
      "fecha: ",
      fecha,
      moment(fecha, "DD/MM/YYYY").format().substring(0, 10)
   );
   const [onChange, setOnChange] = useState(false);
   const [filtrado, setFiltrado] = useState(0);
   const colores = useState([
      "green",
      "blue",
      "red",
      "orange",
      "purple",
      "brown",
      "pink",
      "gray",
      "black",
      "yellow",
   ]);
   const agenda = GetAgendas();
   const events = [];

   const urlUsr = process.env.REACT_APP_URL_DIR + "users";

   const { data } = useQuery({
      queryKey: ["usuario"],
      queryFn: () =>
         fetch(urlUsr, {
            headers: {
               Authorization: `Bearer ${token}`, //mind the space before your token
            },
         }).then((res) => res.json()),
   });

   // if (isLoading) {
   //   return <div>Cargando Informacion</div>;
   // }

   if (data) {
      console.log("profesionales: ", data);
      // for (let i = 0; i < data.length; i++) {
      //   for (let z = 0; z < data.perfilusuarios[i].length; z++) {
      //     if (data.perfilusuarios[i].id[z]===2) {
      //       profesionales.push({id_rank:data[i].id_rank,username:data[i].username})
      //     }
      //   }
      // }
      // console.log('profesionales: ', profesionales);
   }
   // const events = GetAgendas()
   // const [events, setEvents] = useState([]);

   var hmin = 8;
   var hmax = 23;
   var horarios = [];
   var hora = hmin;
   while (hora < hmax) {
      horarios.push({ hora: hora });
      horarios.push({ hora: hora + 0.3 });
      hora += 1;
   }

   const [input, setInput] = useState({
      titulo: "",
      idtit: 0,
      fechadesde: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
      fechahasta: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
      mailDesde: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
      mailHasta: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
      horadesde: hmin,
      horahasta: hmax,
      cliname: "",
      artista: 0,
      email: "",
      usr_id: 1,
      observ: "",
      id: 0,
   });
   const [msg, setMsg] = useState([]);

   const getHorario = (hora) => {
      if (hora.length === 1) hora = `0${hora}:00:00`; //8
      if (hora.length === 2) hora = `${hora}:00:00`; //10
      if (hora.length === 3) {
         hora = `0${hora.replace(".", ":")}0:00`; //8.3}
      }
      if (hora.length === 4) {
         //10.3
         hora = `${hora.replace(".", ":")}0:00`;
      }
      return hora;
   };

   if (agenda && servicios) {
      console.log("entre", filtrado, agenda, servicios);
      for (let i = 0; i < agenda.length; i++) {
         var ag = {
            titulo: "",
            idtit: 0,
            start: "",
            end: "",
            cliname: "",
            artista: "",
            usr_id: "1",
            observ: "",
            email: "",
            id: 0,
         };
         ag.id = agenda[i].id;
         for (let xx = 0; xx < servicios.length; xx++) {
            if (parseInt(agenda[i].titulo) === parseInt(servicios[xx].id)) {
               ag.idtit = agenda[i].titulo;
               ag.titulo = servicios[xx].descripcion;
            }
         }
         ag.start = moment(
            agenda[i].fechadesde + "T" + getHorario(agenda[i].horadesde)
         ).toDate();
         ag.end = moment(
            agenda[i].fechahasta + "T" + getHorario(agenda[i].horahasta)
         ).toDate();
         ag.id = agenda[i].id;
         ag.cliname = agenda[i].cliname;
         ag.artista = agenda[i].artista;
         ag.observ = agenda[i].observ;
         ag.email = agenda[i].email;
         if (parseInt(filtrado) !== 0) {
            if (parseInt(filtrado) === parseInt(agenda[i].artista)) {
               events.push(ag);
            }
         } else {
            events.push(ag);
         }
      }
   }

   const { mutate: deleteAgenda } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "delete",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Calendario";
      },
      onError: () => {
         alert("Error");
      },
   });

   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(url, {
            method: "post",
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Calendario";
      },
      onError: () => {
         alert("Error");
      },
   });

   const filtrar = () => {
      setFiltrado(input.artista);
      console.log("Artista", input.artista);
   };
   const limpiar = (salir) => {
      setInput({
         ...input,
         fechadesde: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
         fechahasta: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
         horadesde: hmin,
         horahasta: hmax,
         titulo: "",
         idtit: 0,
         artista: 0,
         cliname: "",
         observ: "",
         mailDesde: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
         mailHasta: moment(fecha, "DD/MM/YYYY").format().substring(0, 10),
         email: "",
      });
      if (salir) {
         setShowModal(false);
      }
   };

   const eliminar = () => {
      console.log("eliminar", input);
      deleteAgenda(input.id);
      // for (let i = 0; i < events.length; i++) {
      //    console.log("events[i].titulo: ", events[i].titulo, input.titulo);
      //    if (events[i].titulo === input.titulo) {
      //       events.splice(i, 1);
      //       console.log("borre", i);
      //    }
      // }
      // console.log("events: ", events);
      setInput({
         ...input,
         fechadesde: "",
         fechahasta: "",
         horadesde: hmin,
         horahasta: hmax,
         titulo: "",
         idtit: 0,
         artista: 0,
         cliname: 1,
      });
   };

   const grabar = () => {
      var errmsg = [];
      console.log("input.fechadesde: ", input.fechadesde, input.fechahasta);
      setMsg("");
      // permito vacio el campo email
      if (input.email !=="") {
         if (!input.email || !/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(input.email)) {
            errmsg.push("Ingrese un correo válido");
         }
      }
      if (input.titulo === "0") errmsg.push("Ingrese el Servicio");
      if (input.fechadesde === "") errmsg.push("Ingrese fecha Desde");
      if (input.fechahasta === "") errmsg.push("Ingrese fecha Hasta");
      if (input.horadesde === "") errmsg.push("Ingrese horario Desde");
      if (input.horahasta === "") errmsg.push("Ingrese horario Hasta");
      if (parseInt(input.artista) === 0) errmsg.push("Ingrese el Artista");
      if (input.fechahasta < input.fechadesde)
         errmsg.push("Fecha hasta no puede ser menor a Fecha desde");
      if (input.horahasta < input.horadesde)
         errmsg.push("Hora hasta no puede ser menor a Hora desde");
      if (errmsg.length > 0) {
         setMsg(errmsg);
         return;
      }

      for (let xx = 0; xx < servicios.length; xx++) {
         if (input.titulo === servicios[xx].id) {
            input.titulo = servicios[xx].descripcion;
            input.idtit = servicios[xx].id;
         }
      }
      if (input.cliname === 0) input.cliname = 1; // baja por default
      console.log("grabar: ", input);
      var newEvent = {
         titulo: input.titulo,
         fechadesde: input.fechadesde,
         fechahasta: input.fechahasta,
         horadesde: input.horadesde,
         horahasta: input.horahasta,
         cliname: input.cliname,
         artista: input.artista,
         usr_id: "1",
         observ: input.observ,
         idtit: 0,
         id: input.id,
         email: input.email,
      };
      // newEvent.cliname = input.cliname;
      // newEvent.fechadesde = input.fechadesde;
      // newEvent.fechahasta = input.fechahasta;
      // newEvent.horadesde = input.horadesde;
      // newEvent.horahasta = input.horahasta;
      // };
      // newEvent.start = moment(
      //    input.fechadesde + "T" + getHorario(input.horadesde)
      // ).tz("America/New_York");
      // newEvent.end = moment(
      //    input.fechahasta + "T" + getHorario(input.horahasta)
      // ).tz("America/New_York");
      // newEvent.titulo = input.titulo;
      // newEvent.cliname = input.cliname;
      newEvent.artista = input.artista;
      newEvent.observ = input.observ;
      events.push(newEvent);
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
      console.log("newEvent: ", newEvent);
      mutate(newEvent);
   };
   const dollarUSLocale = Intl.NumberFormat("de-DE", {
      minimumIntegerDigits: 1,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
   });

   const handleSelectedEvent = (event) => {
      console.log("event: ", event);
      console.log("start: ", moment(event.start, "DD/MM/YYYY").format());
      var newDesde = parseFloat(
         moment(event.start, "DD/MM/YYYY")
            .format()
            .substring(11, 16)
            .replace(":", "") / 100
      );
      var newHasta = parseFloat(
         moment(event.end, "DD/MM/YYYY")
            .format()
            .substring(11, 16)
            .replace(":", "") / 100
      );
      setInput({
         ...input,
         fechadesde: moment(event.start, "DD/MM/YYYY")
            .format()
            .substring(0, 10),
         fechahasta: moment(event.end, "DD/MM/YYYY").format().substring(0, 10),
         horadesde: newDesde,
         horahasta: newHasta,
         titulo: event.idtit,
         artista: event.artista,
         cliname: event.cliname,
         observ: event.observ,
         email: event.email,
         idtit: event.idtit,
         id: event.id,
      });
      // console.log('handleSelectedEvent event: ', event);
      // console.log("handleSelectedEvent: ", input);
      // input.titulo = input.idtit
      setShowModal(true);
   };
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   function handleMail() {
      var sql =
         "select * from agenda where fechadesde >= '" +
         input.mailDesde +
         "' and fechahasta <= '" +
         input.mailHasta +
         "'";
      if (parseInt(input.artista) > 0) {
         sql += " and artista = " + input.artista;
      }
      console.log("handleMail", sql);
   }

   const components = {
      event: (props) => {
         console.log("props: ", props);
         const { artista, titulo, cliname, observ, email } = props.event;
         if (parseInt(artista) > 0) {
            return (
               <div
                  style={{
                     display: "flex",
                     flexDirection: "row",
                     gap: "5px",
                     background: colores[parseInt(artista)],
                  }}
               >
                  <CiCalendarDate />
                  <span title={observ}>
                     {cliname}
                     <br />
                     {titulo}
                  </span>
               </div>
            );
         }
         return (
            <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
               <CiCalendarDate />
               {props.titulo}
            </div>
         );
      },
   };

   // console.log("events: ", events);
   // console.log("input: ", input);

   return (
      <>
         <div className={style.container}>
            <div className={style.titulo}>
               <h1>Tattoo & Piercing</h1>
               <button
                  className={style.inputBtnNew}
                  onClick={() => setShowModal(true)}
               >
                  Alta Turno
               </button>
               <div>
                  <label>Profesional:</label>
                  <select
                     className={style.agendaselect}
                     id="artista"
                     name="artista"
                     onChange={handleChange}
                     value={input.artista}
                  >
                     <option value="0">Ver Todos</option>
                     {data &&
                        data?.map((dat) => {
                           console.log("dat.username: ", dat.username);
                           for (
                              let i = 0;
                              i <= dat.perfilusuarios.length;
                              i++
                           ) {
                              console.log(
                                 "dat.perfilusuarios[i]: ",
                                 i,
                                 dat.perfilusuarios[i]
                              );
                              if (dat.perfilusuarios[i].id === 2) {
                                 return (
                                    <option
                                       selected
                                       value={dat.id_rank}
                                       key={dat.id_rank}
                                    >
                                       {dat.username}
                                    </option>
                                 );
                              }
                           }
                        })}{" "}
                  </select>{" "}
                  &nbsp;
                  <button
                     onClick={() => filtrar()}
                     className={style.inputBtnNew}
                  >
                     &nbsp;Filtrar
                  </button>
                  <div className={style.mail}>
                     <div>
                        <label>Desde:</label>
                        <input
                           type="date"
                           name="mailDesde"
                           value={input.mailDesde || ""}
                           onChange={handleChange}
                           className={style.formatfecha}
                           style={{ width: "140px" }}
                        />
                        &nbsp;
                     </div>
                     <div style={{ paddingTop: "10px" }}>
                        <label>Hasta:</label>
                        <input
                           type="date"
                           name="mailHasta"
                           value={input.mailHasta || ""}
                           onChange={handleChange}
                           className={style.formatfecha}
                           style={{ width: "140px" }}
                        />
                        &nbsp;
                     </div>
                     <div style={{ paddingTop: "10px" }}>
                        <button
                           className={style.inputBtnNew}
                           onClick={() => {
                              handleMail();
                           }}
                           type="button"
                        >
                           Enviar Mails
                        </button>
                     </div>
                  </div>
               </div>
            </div>
            <div className={style.container}>
               {/* <div style={{ height: "75vh", width: "55vw", zIndex: "2" }}> */}
               <div className={style.divcalendar}>
                  <Calendar
                     localizer={localizer}
                     events={events}
                     onSelectEvent={(event) => handleSelectedEvent(event)}
                     min={moment("2024-09-20T08:00:00").toDate()}
                     max={moment("2024-09-20T18:00:00").toDate()}
                     // cambia formato del dia
                     formats={{
                        dayHeaderFormat: (date) => {
                           return moment(date).format("DD/MM/YYYY");
                        },
                     }}
                     components={components}
                     startAccessor="start"
                     endAccessor="end"
                     className={style.calendar}
                     // style={{ height: 700 }}
                     messages={messages}
                  />
               </div>
               {showModal && (
                  <div className={style.modalOverlay}>
                     <div className={style.modalContent} id="datos">
                        <button
                           className={style.closeModalBtn}
                           onClick={() => limpiar(true)}
                        >
                           X
                        </button>
                        <table>
                           <tbody>
                              <tr className={style.trAgenda}>
                                 <td>Cliente:</td>
                                 <td>
                                    <input
                                       className={style.cliinpt}
                                       id="cliname"
                                       name="cliname"
                                       value={input.cliname}
                                       onChange={handleChange}
                                    />
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Correo:</td>
                                 <td>
                                    <input
                                       className={style.cliinpt}
                                       id="email"
                                       name="email"
                                       value={input.email}
                                       onChange={handleChange}
                                    />
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Servicio:</td>
                                 <td>
                                    <select
                                       className={style.agendaselect}
                                       id="titulo"
                                       name="titulo"
                                       onChange={handleChange}
                                       value={input.titulo}
                                    >
                                       <option value="0">Seleccionar</option>
                                       {servicios &&
                                          servicios?.map((dat) => {
                                             return (
                                                <option
                                                   selected
                                                   value={dat.id}
                                                   key={dat.id}
                                                >
                                                   {dat.descripcion}
                                                </option>
                                             );
                                          })}{" "}
                                    </select>

                                    {/* <input
                                    type="text"
                                    id="titulo"
                                    name="titulo"
                                    onChange={handleChange}
                                    value={input.titulo}
                                    className={style.agendainput}
                                 ></input> */}
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Profesional:</td>
                                 <td>
                                    <select
                                       className={style.agendaselect}
                                       id="artista"
                                       name="artista"
                                       onChange={handleChange}
                                       value={input.artista}
                                    >
                                       <option value="0">Seleccionar</option>
                                       {data &&
                                          data?.map((dat) => {
                                             for (
                                                let i = 0;
                                                i < dat.perfilusuarios.length;
                                                i++
                                             ) {
                                                if (
                                                   dat.perfilusuarios[i].id ===
                                                   2
                                                ) {
                                                   return (
                                                      <option
                                                         selected
                                                         value={dat.id_rank}
                                                         key={dat.id_rank}
                                                      >
                                                         {dat.username}
                                                      </option>
                                                   );
                                                }
                                             }
                                          })}{" "}
                                    </select>{" "}
                                    &nbsp;
                                    {/* <button onClick={() => filtrar()}  className={style.inputBtnNew}>
                                    &nbsp;Filtrar
                                 </button> */}
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Observaciones:</td>
                                 <td>
                                    <textarea
                                       className={style.area}
                                       id="observ"
                                       name="observ"
                                       value={input.observ}
                                       onChange={handleChange}
                                       rows={5}
                                    />
                                 </td>
                              </tr>

                              <tr className={style.trAgenda}>
                                 <td>Inicio:</td>
                                 <td>
                                    <input
                                       className={style.formatfecha}
                                       type="date"
                                       id="fechadesde"
                                       name="fechadesde"
                                       value={input.fechadesde}
                                       onChange={handleChange}
                                    ></input>
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Fin:</td>
                                 <td>
                                    <input
                                       className={style.formatfecha}
                                       type="date"
                                       id="fechahasta"
                                       name="fechahasta"
                                       onChange={handleChange}
                                       value={input.fechahasta}
                                    ></input>
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Desde:</td>
                                 <td>
                                    <select
                                       className={style.agendaselectcenter}
                                       id="horadesde"
                                       name="horadesde"
                                       onChange={handleChange}
                                       value={input.horadesde}
                                    >
                                       <option value="0">Seleccionar</option>
                                       {horarios &&
                                          horarios.map((dat) => {
                                             return (
                                                <option
                                                   selected
                                                   value={dat.hora}
                                                   key={dat.hora}
                                                >
                                                   {`${dollarUSLocale.format(
                                                      dat.hora
                                                   )}`}
                                                </option>
                                             );
                                          })}{" "}
                                    </select>
                                 </td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td>Hasta:</td>
                                 <td>
                                    <select
                                       className={style.agendaselectcenter}
                                       id="horahasta"
                                       name="horahasta"
                                       value={input.horahasta}
                                       onChange={handleChange}
                                    >
                                       <option value="0">Seleccionar</option>
                                       {horarios &&
                                          horarios.map((dat) => {
                                             return (
                                                <option
                                                   selected
                                                   value={dat.hora}
                                                   key={dat.hora}
                                                >
                                                   {`${dollarUSLocale.format(
                                                      dat.hora
                                                   )}`}
                                                </option>
                                             );
                                          })}{" "}
                                    </select>
                                 </td>
                              </tr>

                              {msg &&
                                 msg.map((datamsg) => {
                                    console.log("datamsg: ", datamsg);
                                    return (
                                       <>
                                          <tr className={style.msg}>
                                             <td colSpan={2}>{datamsg}</td>
                                          </tr>
                                       </>
                                    );
                                 })}
                              <tr>
                                 <td colSpan={2}>&nbsp;</td>
                              </tr>
                              <tr className={style.trAgenda}>
                                 <td colSpan={2} className={style.tdcenter}>
                                    <button
                                       onClick={() => grabar()}
                                       className={style.inputBtnNew}
                                    >
                                       Grabar
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button
                                       onClick={() => eliminar()}
                                       className={style.inputBtnNew}
                                    >
                                       Eliminar
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button
                                       onClick={() => limpiar(false)}
                                       className={style.inputBtnNew}
                                    >
                                       Limpiar
                                    </button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               )}
            </div>
         </div>
      </>
   );
}
export default MyCalendar;
